import { InstrumentTypeEnum } from "../../enum/instrument-type.enum";
import { v4 as uuidv4 } from "uuid";

export class InstrumentDto {
  number: string;
  registration_date: string;
  instrument_type: InstrumentTypeEnum;
  uuid: string;

  constructor(instrument_type: InstrumentTypeEnum, number: string, registration_date: string, uuid: string = uuidv4()) {
    this.instrument_type = instrument_type;
    this.number = number;
    this.registration_date = registration_date;
    this.uuid = uuid;
  }

  public static mapInstrumentDisplayToDto = ({ instrument_type, number, registration_date, uuid }: InstrumentDisplay) => {
    return new InstrumentDto(instrument_type, number, registration_date, uuid);
  };
}

export class InstrumentDisplay {
  title: string;
  instrument_type: InstrumentTypeEnum;
  number: string;
  registration_date: string;
  uuid: string;

  constructor(title: string, instrument_type: InstrumentTypeEnum, number: string, registration_date: string, uuid: string = uuidv4()) {
    this.title = title;
    this.instrument_type = instrument_type;
    this.number = number;
    this.registration_date = registration_date;
    this.uuid = uuid;
  }
}
